import React,{useState,useEffect,useRef} from "react";

  import { useRouteMatch,Switch, Route ,Link} from "react-router-dom";
import { useHistory,} from "react-router-dom";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog} from 'lucide-react';

const ContentFolderCard =({title ,onClickPopup})=>{

     const dispatch = useDispatch();
     
      
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
        
    return (<>
        <div   onMouseEnter={
                ()=>handleMouseEnter("","","")}
onMouseLeave={handleMouseLeave}  onClick={()=>onClickPopup()} align="left" className="itemCourseOuterContentFolder"
 style={{marginBottom:"20px",height:"50px",cursor:"pointer",border:"2px dashed #90CAF9",background:" rgba(144, 202, 249,0.1)"}}> 
<div  className="contentItemCardInnergrid" ><div style={{background:"#90CAF9",width:"30px",height:"30px",borderRadius:"55%",
        alignContent:"center",textAlign:"center",padding:"3px",margin:"2px"}}><Plus size={20}  color="#fff"/></div> 

   <div  className="itemContentTitle " style={{fontSize:"15px"}}>{title}</div>
  </div>
 
<div className="set-expiry-card-bottom">
<div></div>
   
   </div>   </div></>)
}
export default ContentFolderCard;

